import { Graphics, ResourceBatch } from 'ohzi-core';
import { RenderLoop } from 'ohzi-core';
import { Configuration } from 'ohzi-core';
import { EventManager } from 'ohzi-core';
import { Debug } from 'ohzi-core';
import { Input } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';

// APP
import MainApplication from './MainApplication';

const application = new MainApplication(Graphics);
const render_loop = new RenderLoop(application, Graphics);

window.ViewApi = {
  init: () =>
  {
    let body = document.querySelector('body');
    let canvas = document.getElementById('main-canvas');

    Configuration.dpr = window.devicePixelRatio;

    let context_attributes = {
      alpha: true,
      depth: true,
      desynchronized: false,
      stencil: false,
      antialias: true,
      premultipliedAlpha: true,
      preserveDrawingBuffer: true,
      powerPreference: 'high-performance',
      logarithmicDepthBuffer: false
    };

    // canvas.getContext('webgl2', context_attributes);

    Graphics.init(canvas, context_attributes);

    Input.init(body, canvas);
    Debug.init(Graphics);
  },

  dispose: () =>
  {
    render_loop.stop();
    Graphics._renderer.dispose();
  },

  draw_debug_axis: () =>
  {
    Debug.draw_axis();
  },

  register_event: (name, callback) =>
  {
    EventManager.on(name, callback);
  },

  on_orientation_change: () =>
  {

  },

  resource_loading_completed: () =>
  {
    application.resources_fully_loaded();
  },

  set_resource: (name, resource) =>
  {
    ResourceContainer.set_resource(name, resource);
  },

  start: () =>
  {
    render_loop.start();
  },

  stop: () =>
  {
    render_loop.stop();
  },

  app: application,
  config: Configuration,
  ResourceContainer: ResourceContainer,
  ResourceBatch: ResourceBatch
};
